exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-manager-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 83vh;\n}\n.create-manager-form__body {\n  margin: 8px 32px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Managers/components/CreateManagerForm/createManagerForm.less
// module id = 1201
// module chunks = 0